import keyboardjs from "keyboardjs";
import { useEffect, useRef } from "react";

import { isInputDOMNode } from "../utils";

export interface UseKeyboardShortcutOptions {
  disabled?: boolean;
}

export const useKeyboardShortcut = (
  key: string | string[],
  callback: () => void,
  options?: UseKeyboardShortcutOptions
) => {
  const { disabled = false } = options || {};
  const callbackRef = useRef(callback);
  const keySignature = JSON.stringify(key);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    const handleKeyDown = (keyboardEvent?: keyboardjs.KeyEvent) => {
      if (!keyboardEvent || isInputDOMNode(keyboardEvent)) {
        return;
      }

      keyboardEvent.preventDefault();

      if (disabled) {
        return;
      }

      callbackRef.current();
    };

    keyboardjs.bind(key, handleKeyDown, undefined, true);

    return () => {
      keyboardjs.unbind(key, handleKeyDown);
    };
  }, [disabled, keySignature]);
};
